var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.emailInfo.isOpen
    ? _c(
        "div",
        { staticClass: "email-status" },
        [
          _c("CompassIcon", {
            attrs: {
              type: "success",
              size: "extra-small",
              icon: "success-circle-fill"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "email-status-text" }, [
            _vm._v(_vm._s(_vm.$l10n.__(_vm.actualStatus)))
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }